/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { FeePayableBySection } from "../../feePayableBy/index";
import { GeneralSection } from "../../general/index";
import { sortBy as _sortBy } from "lodash";

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
  operation,
}) {
  return questionnaire.map(question => {
    if (question.idQuestion === 1384) {
      const chargeType = JSON.parse(questionnaire.find(v => v.idQuestion === 1383)?.answer || null);

      if (chargeType?.id) {
        question.visibleQuestion = chargeType.id == 629;
      }
    }

    if ([2105, 2106].includes(question.idQuestion)) {
      const chargeType = JSON.parse(questionnaire.find(v => v.idQuestion === 1383)?.answer || null);

      question.visibleQuestion = chargeType?.id != 629;
    }

    if (question.idQuestion === 1386) {
      const chargeType = JSON.parse(questionnaire.find(v => v.idQuestion === 1383)?.answer || null);

      if (chargeType?.id == 629) {
        const qst = questionnaire.find(v => v.idQuestion === 1384);
        const { answer } = qst;
        question.visibleQuestion = answer == 0 || answer == "% 0.00000" || answer == "0.00";
        question.isRequired = answer == 0 || answer == "% 0.00000" || answer == "0.00";
        question.behaviorObject.isRequired = answer == 0 || answer == "% 0.00000" || answer == "0.00";
      } else {
        const qst = questionnaire.find(v => v.idQuestion === 2105);
        const dpTax = questionnaire.find(v => v.idQuestion === 2106);
        const { answer } = qst;
        const { answer: answerDpTax } = dpTax;

        const isZero = (val) => val == 0 || val == "% 0.00000" || val == "0.00";
        question.visibleQuestion = isZero(answer) && isZero(answerDpTax);
        question.isRequired = isZero(answer) && isZero(answerDpTax);
        question.behaviorObject.isRequired = isZero(answer) && isZero(answerDpTax);

        if (!question.visibleQuestion) {
          const qst = questionnaire.find(v => v.idQuestion === 2106);
          const apTax = questionnaire.find(v => v.idQuestion === 2105);
          const { answer } = qst;
          const { answer: answerApTax } = apTax;
          const isZero = (val) => val == 0 || val == "% 0.00000" || val == "0.00";
          question.visibleQuestion = isZero(answer) && isZero(answerApTax);
          question.isRequired = isZero(answer) && isZero(answerApTax);
          question.behaviorObject.isRequired = isZero(answer) && isZero(answerApTax);
        }

      }
    }

    if (question.idQuestion === 1465) {
      question.visibleQuestion = operation?.idProduct === 47;
      question.disabled = operation?.idProduct === 47 ? false : true;
      question.behaviorObject.desktopWidth = 10;
      question.behaviorObject.tabletWidth = 10;
      question.behaviorObject.mobileWidth = 10;
    }

    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  insurerGroup,
  insurerGroupUpdated,
  feePayableByGroup,
  setFeePayableByGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {
  try {
    let saveQuestionnaire = false;

    if ([1378, 1379, 1380, 1381, 1382, 1383, 1384, 2105, 2106].includes(question.idQuestion)) {
      saveQuestionnaire = true;

      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if ([1378, 1379, 1380, 1381, 1382, 1383, 1384].includes(qst.idQuestion)) {
          qst.behaviorObject.isRequired = true;
        }
        return qst;
      })
    }

    if (question.idQuestion === 1380 && question.answer) {
      saveQuestionnaire = true;

      FeePayableBySection.events.handleGroup({
        insurerGroup: insurerGroupUpdated,
        feePayableByGroup,
        setFeePayableByGroup,
        questionnaireAnswersToDelete,
        setQuestionnaireAnswersToDelete,
      })

    }

    if (question.idQuestion === 1383) {
      saveQuestionnaire = true;

      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1384) {
          if (value?.id) {
            qst.visibleQuestion = value.id == 629;
          }

          qst.answer = "";
          qst.answerJson = "";
          setFieldValue && setFieldValue(qst.key, "");
        }

        if ([2105, 2106].includes(qst.idQuestion)) {
          if (value?.id) {
            qst.visibleQuestion = value?.id != 629;
          }

          qst.answer = "";
          qst.answerJson = "";
          setFieldValue && setFieldValue(qst.key, "");
        }

        return qst;
      })
    }

    if (question.idQuestion === 1384) {
      saveQuestionnaire = true;
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1386) {
          qst.visibleQuestion = value == "0";
          qst.isRequired = value == "0";
          qst.behaviorObject.isRequired = value == "0";
          qst.answer = "";
          qst.answerJson = "";
          setFieldValue && setFieldValue(qst.key, "");
        }


        return qst;
      })
    }


    if (question.idQuestion === 2106) {
      saveQuestionnaire = true;
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        const qstAp = Number(questionnaireUpdated.find(v => v.idQuestion === 2105)?.answer || 0);

        if (qst.idQuestion === 1386) {
          console.log('soma 2106', value + qstAp)
          const sumTaxes = Number(value) + Number(qstAp);
          const isZero = sumTaxes === 0 || sumTaxes === "0.00";
          qst.visibleQuestion = isZero;
          qst.isRequired = isZero;
          qst.behaviorObject.isRequired = value == "0";
          qst.answer = "";
          qst.answerJson = "";
          setFieldValue && setFieldValue(qst.key, "");
        }
        return qst;
      })
    }

    if (question.idQuestion === 2105) {
      saveQuestionnaire = true;
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        const qstDp = Number(questionnaireUpdated.find(v => v.idQuestion === 2106)?.answer || 0);

        if (qst.idQuestion === 1386) {
          const sumTaxes = Number(value) + Number(qstDp);
          const isZero = sumTaxes === 0 || sumTaxes === "0.00";
          qst.visibleQuestion = isZero;
          qst.isRequired = isZero;
          qst.behaviorObject.isRequired = value == "0";
          qst.answer = "";
          qst.answerJson = "";
          setFieldValue && setFieldValue(qst.key, "");
        }
        return qst;
      })
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('INSURER_TAXES - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  insurerGroup,
  feePayableByGroup,
  setFeePayableByGroup,
}) {
  try {

  } catch (e) {
    console.log("INSURER_TAXES - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('INSURER_TAXES - handleRequestSerproCnpj - error', e)
  }
};

function validateRenderButtons({
  questions,
  isGrouped,
  insurersTaxes,
}) {
  let renderButtons = false;
  let nmInsurer;
  let facilityName;
  let taxName;

  nmInsurer = questions.find((q) => q.idQuestion == 1378)?.answer ? JSON.parse(questions.find((q) => q.idQuestion == 1378)?.answer)?.value : null;
  facilityName = questions.find((q) => q.idQuestion == 1379)?.answer
    ? JSON.parse(questions.find((q) => q.idQuestion == 1379)?.answer)?.value
    : null;
  taxName = questions.find((q) => q.idQuestion == 1380)?.answer ? JSON.parse(questions.find((q) => q.idQuestion == 1380)?.answer)?.value : null;

  if (!nmInsurer || !facilityName || !taxName) {
    return renderButtons;
  }
  if (isGrouped) {
    insurersTaxes.map((fac) =>
      fac.insurers.map((insurer) => {
        insurer?.clientTaxes?.map((taxClient) => {
          if (taxClient?.feeType == taxName) {
            renderButtons = true;
          }
        });
        insurer?.insurerTaxes?.map((taxInsurer) => {
          if (taxInsurer?.feeType == taxName) {
            renderButtons = true;
          }
        });
      })
    );
  } else {
    insurersTaxes.map((fac) =>
      fac.insurers.map((insurer) => {
        let tax =
          insurer?.clientTaxes?.find((tax) => insurer?.nmInsurer == nmInsurer && fac?.name == facilityName && tax?.feeType == taxName) ||
          insurer?.insurerTaxes?.find((tax) => insurer?.nmInsurer == nmInsurer && fac?.name == facilityName && tax?.feeType == taxName);
        if (tax) {
          renderButtons = true;
        }
      })
    );
  }

  return renderButtons;
}

function handleTaxes({
  answerTax,
  insurersAll,
  handleSwitch = false,
  insurerGroup,
  setInsurerGroup,
  feePayableByGroup,
  setFeePayableByGroup,
  insurersTaxes,
  canGroup,
  setCanGroup,
  setIsGrouped,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  questionnaireAnswers = [],
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  operation,
  loading,
  mc,
}) {

  let qtdTaxes;
  let taxes = [];
  let allTaxes = {};
  let isGrouped = answerTax?.idAnswerOption == 6809 || !answerTax?.idAnswerOption;
  let taxesToGroup = {};
  let areTaxesLevelUpdate;
  let arrayToDelete = [];

  if (handleSwitch) {
    arrayToDelete = insurerGroup.flatMap((q) =>
      q.filter((question) => question.idQuestionnaireAnswers).map((question) => question.idQuestionnaireAnswers)
    );

    setQuestionnaireAnswersToDelete([...questionnaireAnswersToDelete, ...arrayToDelete]);
  }

  try {
    if (insurersTaxes.length) {
      if (isGrouped && canGroup) {
        for (const fac of insurersTaxes) {
          for (const key of ["clientTaxes", "insurerTaxes"]) {
            allTaxes[`arrayFrom${key}`] = fac?.insurers?.find((i) => i[key]?.length >= 1)
              ? fac?.insurers?.find((i) => i[key]?.length >= 1)[key]
              : [];

            if (allTaxes[`arrayFrom${key}`]?.length) {
              allTaxes[`arrayFrom${key}`].map((taxClient) => {
                let alreadyExistsTaxes = taxes.find((tax) => tax.feeType == taxClient.feeType);
                if (!alreadyExistsTaxes) {
                  taxes.push(taxClient);
                }
              });
            }
          }
        }
      } else {
        for (const fac of insurersTaxes) {
          for (const insurer of fac.insurers) {
            for (const key of ["clientTaxes", "insurerTaxes"]) {
              if (insurer[key]?.length) {
                insurer[key].map((tax) => {
                  (tax.idPersonInsurer = insurer?.idPersonInsurer),
                    (tax.insurer = insurer?.nmInsurer),
                    (tax.facility = insurer?.nbiRequestInsurerResponse?.facilityName);
                  tax.idQuestionnaireAnswer = insurer?.nbiRequestInsurerResponse?.idQuestionnaireAnswer;
                });
                taxes.push(...insurer[key]);
              }
            }
          }
        }
      }

      let insurerGroupAux = JSON.parse(JSON.stringify(insurersAll || insurerGroup));
      insurerGroupAux = [
        insurerGroupAux[0].map((question) => {
          const { defaultValue } = question.behaviorObject || {};
          question.answer = defaultValue || "";
          question.answerJson = defaultValue || "";
          question.idAnswerOption = null;
          question.idPerson = null;
          question.idQuestionnaireAnswers = null;
          question.idQuestionnaireAnswersParent = null;
          question.idQuestionnaireAnswersRoot = null;
          question.key = null;
          return question;
        }),
      ];

      if (taxes.length && insurerGroupAux.length) {
        qtdTaxes = taxes?.length - insurerGroupAux?.length;

        while (qtdTaxes !== 0) {
          for (const [indexFac, fac] of insurerGroupAux.entries()) {
            if (qtdTaxes == 0) {
              break;
            } else {
              insurerGroupAux = [...insurerGroupAux, GeneralSection.events.createSectionRow({ questions: fac })];
              qtdTaxes = qtdTaxes - 1;
            }
          }
        }

        for (const [indexInsurer, insurer] of insurerGroupAux.entries()) {
          for (const [indexQuestion, question] of insurer.entries()) {
            if (isGrouped && canGroup) {
              if ([1378, 1379].includes(question.idQuestion)) {
                question.answer = JSON.stringify({ value: "All" || "", id: -1 });
                question.answerJson = JSON.stringify({ value: "All" || "", id: -1 });
                question.disabled = true;
              }
            } else {
              if (question.idQuestion == 1378) {
                question.answer = JSON.stringify({ value: taxes[indexInsurer].insurer, id: taxes[indexInsurer].idPersonInsurer });
                question.answerJson = JSON.stringify({ value: taxes[indexInsurer].insurer, id: taxes[indexInsurer].idPersonInsurer });
                question.disabled = true;
              } else if (question.idQuestion == 1379) {
                question.answer = JSON.stringify({ value: taxes[indexInsurer].facility, id: taxes[indexInsurer].idQuestionnaireAnswer });
                question.answerJson = JSON.stringify({ value: taxes[indexInsurer].facility, id: taxes[indexInsurer].idQuestionnaireAnswer });
                question.disabled = true;
              }
            }

            if (question.idQuestion == 1380) {
              question.answer = JSON.stringify({ value: taxes[indexInsurer].feeType || "", id: taxes[indexInsurer].feeTypeDomain });
              question.answerJson = JSON.stringify({ value: taxes[indexInsurer].feeType || "", id: taxes[indexInsurer].feeTypeDomain });
              question.disabled = true;
            } else if (question.idQuestion == 1381) {
              question.answer = JSON.stringify({ value: taxes[indexInsurer].taxType || "", id: taxes[indexInsurer].taxTypeDomain });
              question.answerJson = JSON.stringify({ value: taxes[indexInsurer].taxType || "", id: taxes[indexInsurer].taxTypeDomain });
              question.disabled = true;
            } else if (question.idQuestion == 1382) {
              question.answer = JSON.stringify({ value: taxes[indexInsurer].rateBasis || "", id: taxes[indexInsurer].rateBasisDomain });
              question.answerJson = JSON.stringify({ value: taxes[indexInsurer].rateBasis || "", id: taxes[indexInsurer].rateBasisDomain });
              question.disabled = true;
            } else if (question.idQuestion == 1383) {
              question.answer = JSON.stringify({ value: taxes[indexInsurer].chargeType || "", id: taxes[indexInsurer].chargeTypeDomain });
              question.answerJson = JSON.stringify({ value: taxes[indexInsurer].chargeType || "", id: taxes[indexInsurer].chargeTypeDomain });
            } else if (question.idQuestion == 1384) {
              question.answer = taxes[indexInsurer].chargeTypeDomain == 629 ? (taxes[indexInsurer].feeValue * 100).toFixed(5) : '0';
            } else if (question.idQuestion == 2106) {
              question.answer = taxes[indexInsurer].chargeTypeDomain == 630 ? taxes[indexInsurer].feeValue : '0';
            } else if (question.idQuestion == 2105) {
              question.answer = '0';
            } else if (question.idQuestion == 1465) {
              question.answer = JSON.stringify({
                value: taxes[indexInsurer].government?.PERSON_LAST_NAME || "",
                id: taxes[indexInsurer].government.ID_PERSON,
              });
              question.answerJson = JSON.stringify({
                value: taxes[indexInsurer].government?.PERSON_LAST_NAME || "",
                id: taxes[indexInsurer].government?.ID_PERSON,
              });
              question.disabled = true;
            }
          }
        }
      }

      insurerGroupAux.map((taxRow) => {
        taxRow = handleInitialAdjustments({
          questionnaire: taxRow,
          operation
        });
      });

      insurerGroupAux = _sortBy(insurerGroupAux, function (item) {
        return [item[0].answer, item[1].answer, item[2].answer];
      });

      setInsurerGroup([]);
      setTimeout(() => setInsurerGroup(JSON.parse(JSON.stringify(insurerGroupAux)) || []), 300)
      setCanGroup(canGroup);
      setIsGrouped(isGrouped && canGroup);

      if (!canGroup) {
        setCanGroup(canGroup);
        areTaxesLevelUpdate = questionnaireAnswers.length
          ? questionnaireAnswers.find((q) => q.idQuestion == 1377)
          : globalQuestionnaire.find((q) => q.idQuestion == 1377);
        areTaxesLevelUpdate.answer = "No";
        areTaxesLevelUpdate.idAnswerOption = 6810;

        if (questionnaireAnswers.length) {
          questionnaireAnswers = [...questionnaireAnswers.filter((q) => q.idQuestion != 1377), areTaxesLevelUpdate];
        } else {
          setGlobalQuestionnaire(JSON.parse(JSON.stringify([...globalQuestionnaire.filter((q) => q.idQuestion != 1377), areTaxesLevelUpdate])));
        }
      }

      FeePayableBySection.events.handleGroup({
        insurerGroup: insurerGroupAux,
        feePayableByGroup,
        setFeePayableByGroup,
        questionnaireAnswersToDelete: [...questionnaireAnswersToDelete, ...arrayToDelete],
        setQuestionnaireAnswersToDelete,
      })

      loading.stop();
    }
  } catch (error) {
    mc.error("An error happened, please try again");
    console.error("error: ", error);
    return;
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
  validateRenderButtons,
  handleTaxes,
};

export { events };